import React from 'react'
import { AboutUs, ContactUs, DreamTrip, HeaderScreen, ImpactHighlights, PopularPlaces, WhyChooseUs } from "@/components";
import { BottomImage } from './BottomImge';


export const HomeScreen = () => {
  return (
    <>
    <HeaderScreen/>
    <WhyChooseUs/>
    <DreamTrip/>
    <PopularPlaces/>
    <ImpactHighlights/>
    <AboutUs/>
    <ContactUs/>
    <BottomImage/>
    </>
  )
}